<div class="assignment-custom-tooltip overlay-assignment-tooltip">

    <!-- Header -->
    <div class="assignment-tooltip-header">

        <span class="assignment-tooltip-category">
            {{ category || 'Termin' }}
        </span>

        <div class="assignment-tooltip-title">
            {{ title }}
        </div>

    </div>

    <!-- Inhalt -->
    <div class="assignment-tooltip-body">

        <!-- Zeitraum -->
        <div class="assignment-tooltip-row">
            <mat-icon>event</mat-icon>

            <div>
                <span class="assignment-tooltip-label">
                    Zeitraum
                </span>

                <strong *ngIf="singleDay">
                    {{ startDate | date:'dd.MM.yyyy' }}
                </strong>

                <strong *ngIf="!singleDay">
                    {{ startDate | date:'dd.MM.yyyy' }}
                    –
                    {{ endDate | date:'dd.MM.yyyy' }}
                </strong>
            </div>
        </div>

        <!-- Uhrzeit -->
        <div class="assignment-tooltip-row">
            <mat-icon>schedule</mat-icon>

            <div>
                <span class="assignment-tooltip-label">
                    Uhrzeit
                </span>

                <strong *ngIf="allDay">Ganztägig</strong>
                <strong *ngIf="!allDay">
                    {{ startTime }}
                    –
                    {{ endTime }} Uhr
                </strong>
            </div>
        </div>

        <!-- Auslastung -->
        <div class="assignment-tooltip-row" *ngIf="utilizationPercent !== null">

            <mat-icon>percent</mat-icon>

            <div>
                <span class="assignment-tooltip-label">
                    Auslastung
                </span>

                <strong>
                    {{ utilizationPercent }} %
                </strong>
            </div>
        </div>

        <!-- Mitarbeiter -->
        <div class="assignment-tooltip-row" *ngIf="participants">
            <mat-icon>groups</mat-icon>

            <div>
                <span class="assignment-tooltip-label">
                    Mitarbeiter
                </span>

                <strong>
                    {{ participants }}
                </strong>
            </div>
        </div>

        <!-- Ort -->
        <div class="assignment-tooltip-row" *ngIf="location">

            <mat-icon>place</mat-icon>

            <div>
                <span class="assignment-tooltip-label">
                    Ort
                </span>

                <strong>
                    {{ location }}
                </strong>
            </div>
        </div>

    </div>

    <!-- Status -->
    <div class="assignment-tooltip-footer" *ngIf="footerText">
        <mat-icon>{{ footerIcon }}</mat-icon>
        {{ footerText }}
    </div>

</div>
